import { lazy, Suspense } from "react";
import useLazyChunk from "src/ui/hooks/useLazyChunk";

import { ChunkLoadError, ChunkLoadErrorBoundary } from "./ChunkLoadErrorBoundary";
import type { Props } from "./NewCommandDialog";

// @json-editor/json-editor (697 kB raw) is only reachable from this dialog's tabs, so it is code-split
// behind this lazy import instead of shipping in the main bundle for every user. The boundary and
// Suspense live here, next to the lazy() call, so every call site gets chunk-load-failure handling
// for free instead of having to remember to wrap it.
const importDialog = () =>
    import("./NewCommandDialog")
        .then((module) => ({ default: module.NewCommandDialog }))
        .catch((error) => {
            throw new ChunkLoadError(error);
        });

const LazyNewCommandDialog = lazy(importDialog);

export const useNewCommandDialogChunk = () => useLazyChunk(importDialog);

export const NewCommandDialog = (props: Props) => (
    <ChunkLoadErrorBoundary onError={props.toggleDialog}>
        <Suspense fallback={null}>
            <LazyNewCommandDialog {...props} />
        </Suspense>
    </ChunkLoadErrorBoundary>
);
